import { applicationSettings } from '../../../../settings/application';

import Aurdal from './aurdal';
import Boaxel from './boaxel';
import Bror from './bror';
import Jonaxel from './jonaxel';
import Ivar from './ivar';
import Elvarli from './elvarli';

import { MeansOfNotification } from './meansOfNotification';

export default function validate(tac) {
  switch (applicationSettings.applicationName) {
    case 'AURDAL':
      return Aurdal.validate(tac);
    case 'BROR':
      return Bror.validate(tac);
    case 'BOAXEL':
      return Boaxel.validate(tac);
    case 'JONAXEL':
      return Jonaxel.validate(tac);
    case 'IVAR':
      return Ivar.validate(tac);
    case 'ELVARLI':
      return Elvarli.validate(tac);
    default:
      throw new Error(
        'NotImplementedError',
        'Range-specific tac validation service needed'
      );
  }
}

export { MeansOfNotification };
